var _path, _path2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBellNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.26867 11.75C5.26742 10.8608 5.4421 9.98023 5.78263 9.15888C6.12317 8.33753 6.62284 7.59167 7.25287 6.96426C7.88289 6.33685 8.63083 5.84028 9.45358 5.50317C10.2763 5.16605 11.1577 4.99503 12.0468 4.99998C15.7593 5.02811 18.7312 8.11248 18.7312 11.8344V12.5C18.7312 15.8562 19.4343 17.8062 20.053 18.875C20.1188 18.9888 20.1534 19.1179 20.1535 19.2493C20.1536 19.3808 20.1192 19.5099 20.0537 19.6238C19.9882 19.7378 19.8939 19.8325 19.7802 19.8985C19.6666 19.9645 19.5376 19.9995 19.4062 20H4.59367C4.46224 19.9995 4.33324 19.9645 4.2196 19.8985C4.10595 19.8325 4.01165 19.7378 3.94613 19.6238C3.88062 19.5099 3.8462 19.3808 3.84631 19.2493C3.84643 19.1179 3.88108 18.9888 3.9468 18.875C4.56555 17.8062 5.26867 15.8562 5.26867 12.5V11.75Z",
    stroke: "#8E8E8E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 20V20.75C9 21.5456 9.31607 22.3087 9.87868 22.8713C10.4413 23.4339 11.2044 23.75 12 23.75C12.7956 23.75 13.5587 23.4339 14.1213 22.8713C14.6839 22.3087 15 21.5456 15 20.75V20",
    stroke: "#8E8E8E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 6,
    r: 5,
    fill: "#E2B351",
    stroke: "#FEFEFE",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellNotification);
export default __webpack_public_path__ + "static/media/Bell-notification.f6ca1616b19a934c55bb532e1d4671b4.svg";
export { ForwardRef as ReactComponent };